import { TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import { useTranslation } from 'react-i18next';
import { useGetSettlementListInfinite } from 'services/settlementPeriods';
import {
  IResponsSettlementPeriods,
  SETTLEMENT_PERIOD_TYPE_ENUM,
} from 'services/settlementPeriods/types';
import { INodes } from 'services/types';
import { magellanColumns } from 'types/components/table/table.types';
import { formatDate } from 'utils/global/date.utils';
import { getSettlementPeriodName } from 'utils/global/name.utils';
import { getNodes } from 'utils/table/nodes.utils';

enum SORT_COLUMNS {
  name,
  startDate,
  endDate,
  year,
}

const SettelmentPeriod = () => {
  usePermissionGuard('SettlementPeriodPermissionsLIST**');

  const { t } = useTranslation();
  const i18nextPrefix = 'settlement-periods';

  const columnsVisibility = useTableColumnsVisibility(
    'SettlementPeriod1',
    SORT_COLUMNS
  );

  const { data, isLoading, fetchNextPage, isFetchingNextPage } =
    useGetSettlementListInfinite({ pageSize: 25 });

  const tableData: INodes<IResponsSettlementPeriods> =
    getNodes<IResponsSettlementPeriods>(data?.pages.flat());

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`${i18nextPrefix}.title.list`)}
          hideBackButton
          topbarContent={
            <>
              <Table.CustomColumnsButton
                columns={SORT_COLUMNS}
                isClear
                visibility={columnsVisibility}
                i18nextPrefix='input.label'
                customI18next=''
              />
            </>
          }
        />
      }>
      <Table
        id={columnsVisibility.tableId}
        loading={isLoading || isFetchingNextPage}
        onFullyScroll={fetchNextPage}
        data={tableData}
        columns={magellanColumns<IResponsSettlementPeriods>([
          {
            label: t('input.label.name'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text
                  text={getSettlementPeriodName(item.settlementPeriodName)}
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.name),
          },
          {
            label: t('input.label.startDate'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={formatDate(item.startDate)} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.startDate),
          },
          {
            label: t('input.label.endDate'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={formatDate(item.endDate)} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.endDate),
          },
          // {
          //   label: t('input.label.year'),
          //   renderCell: item => (
          //     <TableItem>
          //       <TableItem.Text
          //         text={item.settlementPeriodName.year.toString()}
          //       />
          //     </TableItem>
          //   ),
          //   resize: true,
          //   hide: columnsVisibility.hide(SORT_COLUMNS.year),
          // },
          {
            label: t('input.label.type'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text
                  text={t(
                    `enum.SETTLEMENT_PERIOD_TYPE.${
                      SETTLEMENT_PERIOD_TYPE_ENUM[item.settlementPeriodType.id]
                    }`
                  )}
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.year),
          },
        ])}
      />
    </TopbarPage>
  );
};

export default SettelmentPeriod;
